<template>
  <div class="con-bar-nav-app">
    <van-tabbar v-model="active" fixed @change="onChange">
      <van-tabbar-item @click="routerPush('/home')">
        <span>首页</span>
        <template #icon="props">
          <img class="imgBox" :src="props.active ? home.active : home.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item @click="routerPush('/mine')">
        <span>我的</span>
        <template #icon="props">
          <span class="badgeF">
            <van-badge dot class="badgeIcon" v-if="badgeFlag" />
            <img class="imgBox" :src="props.active ? mine.active : mine.inactive">
          </span>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import {findFormNoticeForEnter,} from "@/apis/filling.js";
/**
 * AppNavBar组件
 */
export default {
  name: "AppNavBar",
  data() {
    return {
      time: null,
      badgeFlag: false,
      userType: "",
      isAdmin: "",
      active: 0,
      home: {
        active: require("@/assets/images/tabbar/home3x.png"),
        inactive: require("@/assets/images/tabbar/home_3x.png")
      },
      mine: {
        active: require("@/assets/images/tabbar/mine3x.png"),
        inactive: require("@/assets/images/tabbar/mine_3x.png")
      }
    };
  },
  watch: {
    $route: {
      handler: function () {
        this.handler();
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters(['isDemonstration', 'userAccountType'])
  },
  created() {
    this.userType = localStorage.getItem("user_type");
    this.isAdmin = localStorage.getItem("user_isAdmin");

  },
  beforeDestroy() {
    clearInterval(this.time)
    this.time = null
  },
  methods: {
    onChange(index) {
      this.active = index;
    },
    routerPush(url, i) {
      this.$router.push(url);
    },
    handler: function () {
      switch (this.$router.history.current.fullPath) {
        case "/home":
          this.active = 0;
          this.badgeFlag = false
          break;
        case "/mine":
          this.active = 1;
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
::v-deep .van-tabbar {
  height: 62px;
  box-shadow: 0px -2px 24px 0px rgba(0, 0, 0, 0.22);
  overflow: hidden;
}

.badgeF {
  position: relative;
}

.badgeIcon {
  position: absolute;
  top: 0;
  right: 0;
}

.imgBox {
  width: 22px;
  height: 22px;
  margin-bottom: 4px;
}
</style>
